import { useState, useEffect } from 'react';
import { siteInfo } from '@/mocks/homeData';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navItems = [
    { label: '首页', href: '#hero' },
    { label: '更新快讯', href: '#updates' },
    { label: '关于我们', href: '#about' },
    { label: '热门榜单', href: '#ranking' },
    { label: '专题索引', href: '#index' },
    { label: '读者评价', href: '#comments' },
    { label: '联系我们', href: '#contact' },
  ];

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex items-center justify-between px-4 md:px-6 h-16 max-w-[1400px]">
        <a href="#hero" className="flex items-center gap-2 whitespace-nowrap cursor-pointer" onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}>
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-flower-line text-xl text-primary-500"></i>
          </div>
          <span className="font-heading text-xl text-foreground-900 tracking-wide">
            {siteInfo.name}
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
              className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-500 rounded-md hover:bg-primary-50/60 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <nav className="flex flex-col px-4 py-3 gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                className="px-4 py-2.5 text-sm text-foreground-700 hover:text-primary-500 hover:bg-primary-50/60 rounded-md transition-colors duration-200 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}